import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Header from "../Header";

import "../../styles/theme.css";
import "../../styles/dashboard.css";
import "../../styles/ProfilesManager.css";

export default function AIEndpointOverview() {
  const { t } = useTranslation("help");

  return (
    <div className="theme-whbl">
      {/* Internal CSS */}
      <style>
        {`
          .help-row {
            display: block;
            gap: 16px;
            padding: 16px 18px;
            border-bottom: 1px solid #e5e7eb;
            align-items: flex-start;
          }

          .help-row:last-child {
            border-bottom: none;
          }

          .help-row p {
            width: 100%;
            max-width: 100%;
            margin: 0;
            font-size: 14px;
            line-height: 1.6;
            color: #fff;
          }

          .help-row img {
            width: 100%;
            max-width: 650px;
            border-radius: 6px;
            padding: 10px;
            transition: transform 0.8s ease;
            margin: 10px 0;
          }

          .help-row img:hover {
          }

          @media (max-width: 768px) {
            .help-row {
              flex-direction: column;
            }

            .help-row p,
            .help-row img {
              width: 100%;
              max-width: 100%;
            }
          }
        `}
      </style>

      <div className="container-fluid">
        <div className="main-container">

          {/* Main Content */}
          <main style={{ width: "100%" }}>
            <div className="dashboard">

              {/* Title */}
              <div className="pm-header">
                <h1 className="pm-title">
                  {t("aiEndpointOverview.title")}
                </h1>
              </div>

              {/* Content */}
              <div
                style={{
                  backgroundColor: "#10172a",
                  borderRadius: "6px",
                  marginTop: "15px",
                  overflow: "hidden",
                }}
              >
                {/* Intro / Step 1 */}
                <div className="help-row">
                  <p>
                    {t("aiEndpointOverview.intro.description")}
                  </p>

                  <p
                    style={{
                      padding: "5px",
                      border: "1px solid #36559f",
                      margin: "10px 0",
                    }}
                  >
                    {t("aiEndpointOverview.intro.plainEnglish")}
                  </p>

                  <img
  src={t("aiEndpointOverview.intro.image")}
  alt={t("aiEndpointOverview.intro.imageAlt")}
  
/>
<br/><br/>

       <img
  src={t("aiEndpointOverview.intro.image2")}

/>
<br/><br/>


       <img
  src={t("aiEndpointOverview.intro.image3")}

/>

<br/><br/>


       <img
  src={t("aiEndpointOverview.intro.image4")}

/>

<br/><br/>


     



                </div>

                {/* Step 2 Overview Table */}
                <div className="help-row">
                  <div className="dark-table-container">
                    <table className="dark-guide-table">
                      <thead>
                        <tr>
                          <th>{t("aiEndpointOverview.overviewTable.headers.field")}</th>
                          <th>{t("aiEndpointOverview.overviewTable.headers.meaning")}</th>
                          <th>{t("aiEndpointOverview.overviewTable.headers.howToFill")}</th>
                        </tr>
                      </thead>

                      <tbody>
                        <tr>
                          <td>{t("aiEndpointOverview.overviewTable.rows.endpointName.field")}</td>
                          <td>{t("aiEndpointOverview.overviewTable.rows.endpointName.meaning")}</td>
                          <td>{t("aiEndpointOverview.overviewTable.rows.endpointName.howToFill")}</td>
                        </tr>

                        <tr>
                          <td>{t("aiEndpointOverview.overviewTable.rows.endpointDescription.field")}</td>
                          <td>{t("aiEndpointOverview.overviewTable.rows.endpointDescription.meaning")}</td>
                          <td>{t("aiEndpointOverview.overviewTable.rows.endpointDescription.howToFill")}</td>
                        </tr>

                        <tr>
                          <td>{t("aiEndpointOverview.overviewTable.rows.selectAiEndpoint.field")}</td>
                          <td>{t("aiEndpointOverview.overviewTable.rows.selectAiEndpoint.meaning")}</td>
                          <td>{t("aiEndpointOverview.overviewTable.rows.selectAiEndpoint.howToFill")}</td>
                        </tr>

                        <tr>
                          <td>{t("aiEndpointOverview.overviewTable.rows.navigation.field")}</td>
                          <td>{t("aiEndpointOverview.overviewTable.rows.navigation.meaning")}</td>
                          <td>{t("aiEndpointOverview.overviewTable.rows.navigation.howToFill")}</td>
                        </tr>
                      </tbody>
                    </table>

                    <style>{`
                      .dark-table-container {
                        width: 100%;
                        margin: 20px 0;
                        overflow-x: auto;
                        background: #111827;
                        padding: 0;
                        box-sizing: border-box;
                      }

                      .dark-guide-table {
                        width: 100%;
                        border-collapse: collapse;
                        table-layout: fixed;
                        font-family: "Segoe UI", Arial, sans-serif;
                        font-size: 14px;
                        color: #e5e7eb;
                        background: #111827;
                        border: 1px solid #374151;
                      }

                      /* Header */
                      .dark-guide-table thead th {
                        background: #1f2937;
                        color: #60a5fa;
                        font-weight: 700;
                        text-align: left;
                        padding: 12px 14px;
                        border: 1px solid #4b5563;
                        vertical-align: middle;
                      }

                      /* Body cells */
                      .dark-guide-table tbody td {
                        background: #111827;
                        color: #e5e7eb;
                        padding: 12px 14px;
                        border: 1px solid #374151;
                        vertical-align: top;
                        line-height: 1.55;
                      }

                      /* Slight alternate row */
                      .dark-guide-table tbody tr:nth-child(even) td {
                        background: #172033;
                      }

                      /* Hover */
                      .dark-guide-table tbody tr:hover td {
                        background: #1e293b;
                      }

                      /* Column widths */
                      .dark-guide-table th:nth-child(1),
                      .dark-guide-table td:nth-child(1) {
                        width: 23%;
                      }

                      .dark-guide-table th:nth-child(2),
                      .dark-guide-table td:nth-child(2) {
                        width: 37%;
                      }

                      .dark-guide-table th:nth-child(3),
                      .dark-guide-table td:nth-child(3) {
                        width: 40%;
                      }

                      /* Mobile */
                      @media (max-width: 768px) {
                        .dark-table-container {
                          overflow-x: auto;
                        }

                        .dark-guide-table {
                          min-width: 750px;
                        }
                      }
                    `}</style>
                  </div>

                  <h1>{t("aiEndpointOverview.aiAppSection.title")}</h1>
                  <p>{t("aiEndpointOverview.aiAppSection.description")}</p>

                 

                  <table className="dark-guide-table">
                    <thead>
                      <tr>
                        <th>{t("aiEndpointOverview.aiAppSection.table.headers.field")}</th>
                        <th>{t("aiEndpointOverview.aiAppSection.table.headers.purpose")}</th>
                        <th>{t("aiEndpointOverview.aiAppSection.table.headers.detail")}</th>
                      </tr>
                    </thead>

                    <tbody>
                      <tr>
                        <td>{t("aiEndpointOverview.aiAppSection.table.rows.url.field")}</td>
                        <td>{t("aiEndpointOverview.aiAppSection.table.rows.url.purpose")}</td>
                        <td>{t("aiEndpointOverview.aiAppSection.table.rows.url.detail")}</td>
                      </tr>

                      <tr>
                        <td>{t("aiEndpointOverview.aiAppSection.table.rows.scriptsTab.field")}</td>
                        <td>{t("aiEndpointOverview.aiAppSection.table.rows.scriptsTab.purpose")}</td>
                        <td>{t("aiEndpointOverview.aiAppSection.table.rows.scriptsTab.detail")}</td>
                      </tr>

                      <tr>
                        <td>{t("aiEndpointOverview.aiAppSection.table.rows.jsonsTab.field")}</td>
                        <td>{t("aiEndpointOverview.aiAppSection.table.rows.jsonsTab.purpose")}</td>
                        <td>{t("aiEndpointOverview.aiAppSection.table.rows.jsonsTab.detail")}</td>
                      </tr>

                      <tr>
                        <td>{t("aiEndpointOverview.aiAppSection.table.rows.inputScriptSingle.field")}</td>
                        <td>{t("aiEndpointOverview.aiAppSection.table.rows.inputScriptSingle.purpose")}</td>
                        <td>{t("aiEndpointOverview.aiAppSection.table.rows.inputScriptSingle.detail")}</td>
                      </tr>

                      <tr>
                        <td>{t("aiEndpointOverview.aiAppSection.table.rows.inputScriptMulti.field")}</td>
                        <td>{t("aiEndpointOverview.aiAppSection.table.rows.inputScriptMulti.purpose")}</td>
                        <td>{t("aiEndpointOverview.aiAppSection.table.rows.inputScriptMulti.detail")}</td>
                      </tr>

                      <tr>
                        <td>{t("aiEndpointOverview.aiAppSection.table.rows.outputScript.field")}</td>
                        <td>{t("aiEndpointOverview.aiAppSection.table.rows.outputScript.purpose")}</td>
                        <td>{t("aiEndpointOverview.aiAppSection.table.rows.outputScript.detail")}</td>
                      </tr>

                      <tr>
                        <td>{t("aiEndpointOverview.aiAppSection.table.rows.requestJson.field")}</td>
                        <td>{t("aiEndpointOverview.aiAppSection.table.rows.requestJson.purpose")}</td>
                        <td>{t("aiEndpointOverview.aiAppSection.table.rows.requestJson.detail")}</td>
                      </tr>

                      <tr>
                        <td>{t("aiEndpointOverview.aiAppSection.table.rows.responseJson.field")}</td>
                        <td>{t("aiEndpointOverview.aiAppSection.table.rows.responseJson.purpose")}</td>
                        <td>{t("aiEndpointOverview.aiAppSection.table.rows.responseJson.detail")}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

            </div>
          </main>

        </div>
      </div>
    </div>
  );
}